/* セレクト */
import React from 'react';
import { Form, Col, Row } from 'react-bootstrap';
import RowTemplate from '../atoms/RowTemplate';
import { KeyValue } from '../types/KeyValue';
import Messages from '../molecules/Messages';
import Paragraph from '../molecules/Paragraph';

interface Props {
  id: string;
  label: string;
  need?: boolean;
  sources: Array<KeyValue>;
  value: string;
  name: string;
  handleChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  message?: string;
  help_msg?: string;
  disabled: boolean;
  suffix: string;
  handleBlur?: VoidFunction;
  with_empty_option?: boolean;
  looks_inactive?: boolean;
  readonly?: boolean;
}

const Select: React.FC<Props> = ({
  id,
  label,
  need,
  sources,
  value,
  handleChange,
  name,
  message,
  help_msg,
  disabled,
  suffix,
  handleBlur,
  with_empty_option,
  looks_inactive,
  readonly,
}) => {
  const returnFormSelectJsx = () => {
    return suffix ? (
      <>
        <Row className="align-items-end sp-select-row">
          <Col md={6} lg={6} xl={6} className="mr-3 sp-select-col">
            <div className="p-select">
              <Form.Control
                className="c-select"
                id={id}
                as="select"
                custom
                onChange={handleChange}
                name={name}
                disabled={disabled || readonly}
                value={value}
                onBlur={handleBlur}
              >
                {with_empty_option && (
                  <option key="" value="">
                    選択して下さい
                  </option>
                )}
                {sources.map(src => {
                  return (
                    <option key={src.key} value={src.key}>
                      {src.value}
                    </option>
                  );
                })}
              </Form.Control>
            </div>
          </Col>
          <Col md={5} lg={5} xl={5}>
            {suffix}
          </Col>
        </Row>
        <Messages help_msg={help_msg} valid_msg={message} />
      </>
    ) : (
      <>
        <div
          className={`sp-select p-select ${name === 'receptions.loan_type' &&
            'large-form'} ${message && '-error'}`}
        >
          <Form.Control
            id={id}
            as="select"
            custom
            onChange={handleChange}
            name={name}
            disabled={disabled || readonly}
            value={value}
            onBlur={handleBlur}
            className={`sp-form-select ${name === 'receptions.loan_type' &&
              'large-form'} ${message && 'textarea-error'}`}
          >
            {with_empty_option && (
              <option key="" value="">
                選択して下さい
              </option>
            )}
            {sources.map(src => {
              return (
                <option key={src.key} value={src.key}>
                  {src.value}
                </option>
              );
            })}
          </Form.Control>
        </div>
        <Messages help_msg={help_msg} valid_msg={message} />
      </>
    );
  };

  /**
   * ラベルを描画する
   * @return JSX.Element ラベルのElement
   */
  const returnLabelJsx = () => {
    return suffix ? (
      <>
        {sources.map((src, index) => {
          return src.key === value && <Paragraph key={index} label={`${src.value}${suffix}`} />;
        })}
      </>
    ) : (
      <>
        {sources.map((src, index) => {
          return src.key === value && <Paragraph key={index} label={src.value} />;
        })}
      </>
    );
  };
  return (
    <RowTemplate
      label={label}
      need={need}
      disabled={disabled}
      looks_inactive={looks_inactive}
      content={disabled || looks_inactive ? returnLabelJsx() : returnFormSelectJsx()}
    />
  );
};

export default Select;
